<template>
  <div class="sop-container">
    <div class="search-container">
      <el-date-picker
        v-model="searchSelectTime"
        size="mini"
        type="daterange"
        :editable="false"
        value-format="yyyy-MM-dd"
        range-separator="~"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="selectTime"
        :picker-options="pickerOptions"
        :clearable="false"
        style="width: 240px; margin-right: 10px"
      >
      </el-date-picker>
      <el-select
        v-model="selectTypeList"
        multiple
        collapse-tags
        placeholder="回访类型"
        size="mini"
        @change="selectType"
        style="width: 180px; margin-right: 10px;"
      >
        <el-option
          v-for="(item, index) in typeOptions"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="getListParams.rviDoStatus"
        clearable
        placeholder="回访状态"
        size="mini"
        @change="selectStatus"
        style="width: 140px; margin-right: 10px;"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        placeholder="回访计划内容"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="getListParams.rviTitle"
        clearable
        style="width: 190px; margin-right: 10px;"
      >
      </el-input>

      <el-input
        placeholder="客户姓名"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="getListParams.ctmKeyWord"
        clearable
        style="width: 190px; margin-right: 10px;"
      >
      </el-input>
    </div>
    <tableWrap>
      <template #table>
        <el-table
          size="medium"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          ref="returnVisitSOPTable"
          height="calc(100vh - 290px)"
          :highlight-current-row="true"
          :data="tableData"
          style="width: 100%;font-size: 13px"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
          />
          <el-table-column
            prop="rviTitle"
            label="回访计划"
            min-width="200"
            align="left"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="回访计划"
                width="200"
                trigger="hover"
                popper-class="rvi-popover"
                :content="scope.row.rviTitle"
              >
                <div slot="reference" class="ellipsis">
                  {{ scope.row.rviTitle }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="rviType"
            label="回访类型"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.rviType || "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="回访方式"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.typeName || "--" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="rviDoStatus"
            label="回访状态"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.rviDoStatus == 'Y'">已回访</span>
                <span v-else-if="scope.row.rviDoStatus == 'T'">未回访</span>
                <span v-else>待回访</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ctmKeyWord"
            label="回访员工"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div
                style="display: flex;align-items:center;justify-content: center;"
              >
                <div class="ellipsis-6" :title="scope.row.rviEmpName">
                  {{ scope.row.rviEmpName }}
                </div>
                <div
                  style="display: flex;align-items:center;"
                  v-if="
                    scope.row.visitUserName && scope.row.visitUserName != null
                  "
                >
                  (
                  <div class="ellipsis-6" :title="scope.row.visitUserName">
                    {{ scope.row.visitUserName }}
                  </div>
                  <span
                    style="color: rgba(255, 92, 0, 0.85);"
                    v-if="scope.row.externalUserIdQy == 2"
                    >@企微</span
                  >
                  <span style="color: rgb(70, 189, 10);" v-else>@微信</span>
                  )
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="kehu"
            label="回访客户"
            min-width="250"
            align="center"
          >
            <template slot-scope="scope">
              <div
                style="display: flex;align-items:center;justify-content: center;"
              >
                <div class="ellipsis-6" :title="scope.row.ctmName">
                  {{ scope.row.ctmName }}
                </div>
                <div
                  style="display: flex;align-items:center;"
                  v-if="
                    scope.row.visitCusName && scope.row.visitCusName != null
                  "
                >
                  (
                  <div class="ellipsis-6" :title="scope.row.visitCusName">
                    {{ scope.row.visitCusName }}
                  </div>
                  <span
                    style="color: rgba(255, 92, 0, 0.85);"
                    v-if="scope.row.externalUserIdQy == 2"
                    >@企微</span
                  >
                  <span style="color: rgb(70, 189, 10);" v-else>@微信</span>
                  )
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="rviNext"
            label="回访日期"
            min-width="180px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="rviTime"
            label="实际回访时间"
            min-width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="rviInfo"
            label="回访情况"
            min-width="250px"
            align="center"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                v-if="scope.row.rviInfo"
                title="回访情况"
                width="350"
                trigger="hover"
                popper-class="rvi-popover"
                :content="scope.row.rviInfo"
              >
                <div slot="reference" class="ellipsis">
                  {{ scope.row.rviInfo }}
                </div>
              </el-popover>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createMsg"
            label="创建信息"
            min-width="300px"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column  label="操作" fixed="right" min-width="68px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="KHSOPxbc && scope.row.showStatus"
                  class="table-button"
                  type="text"
                  size="small"
                  @click.stop="handleDel(scope.row)"
                  >删除</el-button
                >
              </template> 
            </el-table-column> -->
        </el-table>
      </template>
      <template #pagination>
        <Pagination
          v-bind:childMsg="pageparm"
          :pageSizes="pageSizes"
          @callBack="callBack"
        ></Pagination>
      </template>
    </tableWrap>
  </div>
</template>
<script>
import {
  getVisitSopDetail,
  getVisitSopType,
  deleteVisitSop,
} from "@/api/sop/sop.js";
import tableWrap from "@/components/tabelWrap.vue";
export default {
  name: "ReturnVisitSOP",
  components: {
    tableWrap,
  },
  data() {
    return {
      activeName: "first",
      searchSelectTime: [this.getNowTime(), this.getNowTime()],
      selectTypeList: [],
      getListParams: {
        startTime: this.getNowTime(),
        endTime: this.getNowTime(),
        rviTypesStr: "", //回访类型【String，未选择传""】
        rviDoStatus: "", //回访状态【String，T：未回访 N：待回访 Y：已回访，未选择传""】
        rviTitle: "", //回访计划内容【String，未选择传""】
        current: 1, //当前页码 不传默认1
        size: 100, //每页条数 不传默认10
        ctmKeyWord: "", //回访员工
      },
      pageparm: {
        currentPage: 1,
        pageSize: 100,
        total: 0,
      },
      /** 回访方式 0 人工回访 1企微回访 */
      typeHuiOptions: [
        { label: "人工回访", value: 0 },
        { label: "企微回访", value: 1 },
        { label: "AI回访", value: 2 },
      ],
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      // 回访类型选项
      typeOptions: [],
      // 回访状态选项
      statusOptions: [
        {
          label: "未回访",
          value: "T",
        },
        {
          label: "待回访",
          value: "N",
        },
        {
          label: "已回访",
          value: "Y",
        },
      ],
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              console.log("23123", start, end);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log("week", week);
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      hasMoreArrow: false,
      KHSOPxbc: false, // 可新建/编辑/删除
    };
  },
  created() {
    this.getReturnType();
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "客户SOP") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("KHSOPxbc") != -1) {
                this.KHSOPxbc = true;
              } else {
                this.KHSOPxbc = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      console.log(defaultDate);
      return defaultDate;
      // this.$set(this.info, "stockDate", defaultDate);
    },
    callBack(parm) {
      this.getListParams.current = parm.currentPage;
      this.getListParams.size = parm.pageSize;
      this.getList();
    },
    searchFn() {
      this.getListParams.current = 1;
      this.getList();
    },
    // 时间处理
    selectTime(dataTime) {
      if (dataTime != null) {
        this.getListParams.startTime = dataTime[0];
        this.getListParams.endTime = dataTime[1];
      }
      this.getListParams.current = 1;
      this.getList();
    },
    selectType() {
      this.getListParams.rviTypesStr = this.selectTypeList.join(",");
      this.getListParams.current = 1;
      this.getList();
    },
    selectStatus() {
      this.getListParams.current = 1;
      this.getList();
    },
    handleDel(row) {
      this.$confirm("您确定删除该回访计划？提交后将无法撤回？", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        title: "删除",
        cancelButtonText: "取消",
      })
        .then((res) => {
          this.deleteItem(row.rviCode, row.earId);
        })
        .catch((action) => {
          // that.$message("取消删除");
          this.$message({
            message: "取消删除",
            type: "info",
            offset: 30,
            customClass: "info-message",
          });
        });
    },
    deleteItem(code, id) {
      let obj = { delRviCode: code, earId: id };
      deleteVisitSop(obj, localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        } else {
          this.$message({
            message: "删除失败！" + res.error.message,
            type: "error",
          });
        }
      });
    },
    // 获取列表数据
    getList() {
      getVisitSopDetail(
        this.getListParams,
        localStorage.getItem("Authorization"),
      )
        .then((res) => {
          if (res.error.code == 200) {
            // 处理回访方式的显示
            res.data.listVisitSop.forEach((item) => {
              item.typeName =
                this.typeHuiOptions.find((h) => h.value == item.type)?.label ||
                "--";
            });

            this.tableData = res.data.listVisitSop;
            this.pageparm.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 获取回访类型
    getReturnType() {
      getVisitSopType(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.typeOptions = res.data;
          this.getList();
        }
      });
    },
  },
};
</script>
<style lang="scss">
.rvi-popover {
  padding: 14px !important;
  .el-popover__title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 13px;
    border-bottom: 1px solid #eeeff3;
  }
}
</style>
<style lang="scss" scoped>
.sop-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-container {
    margin-bottom: 12px;
  }
  .ellipsis {
    position: relative;
    padding-right: 3px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .ellipsis-6 {
    max-width: 6em;
    text-overflow: ellipsis;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
  }
  .switch-arrow {
    color: red;
  }
}
</style>
